import { Grid, IconButton, MenuItem, Select, Typography } from "@mui/material";
import { Box, Stack } from "@mui/system";
import React from "react";
import Input from "../../../../../component/input";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";

interface HouseCleanProps {
  formik: any;
}

const HouseCleanCommercial: React.FC<HouseCleanProps> = ({ formik }) => {
  const handleAddButton = (id: number) => {
    if (id === 1) {
      formik.setFieldValue("cleaningArea", [...formik.values.cleaningArea, ""]);
      formik.setFieldValue("cleaningAreaPrice", [
        ...formik.values.cleaningAreaPrice,
        "",
      ]);
    }

    if (id === 2) {
      formik.setFieldValue("noOftoilet", [...formik.values.noOftoilet, ""]);
      formik.setFieldValue("noOftoiletPrice", [
        ...formik.values.noOftoiletPrice,
        "",
      ]);
    }
  };

  const handleRemoveButton = (id: number, itemId: number) => {
    if (itemId === 1) {
      const newNoOfBedroom = [...formik.values.cleaningArea];
      newNoOfBedroom.splice(id, 1);
      formik.setFieldValue("cleaningArea", newNoOfBedroom);

      const newNoOfBdrmPrice = [...formik.values.cleaningAreaPrice];
      newNoOfBdrmPrice.splice(id, 1);
      formik.setFieldValue("cleaningAreaPrice", newNoOfBdrmPrice);
    }

    if (itemId === 2) {
      const newNoOfbathroom = [...formik.values.noOftoilet];
      newNoOfbathroom.splice(id, 1);
      formik.setFieldValue("noOftoilet", newNoOfbathroom);

      const newNoOfbathrmPrice = [...formik.values.noOftoiletPrice];
      newNoOfbathrmPrice.splice(id, 1);
      formik.setFieldValue("noOftoiletPrice", newNoOfbathrmPrice);
    }
  };

  const handleChange = (id: number, newValue: any, itemId: number) => {
    if (itemId === 1) {
      const newPrices = [...formik.values.cleaningAreaPrice];
      newPrices[id] = newValue;
      formik.setFieldValue("cleaningAreaPrice", newPrices);
    }

    if (itemId === 2) {
      const newPrices = [...formik.values.noOftoiletPrice];
      newPrices[id] = newValue;
      formik.setFieldValue("noOftoiletPrice", newPrices);
    }
  };

  const handleSelect = (id: number, newValue: any, itemId: number) => {
    if (itemId === 1) {
      const newNoOfBedroom = [...formik.values.cleaningArea];
      newNoOfBedroom[id] = newValue;
      formik.setFieldValue("cleaningArea", newNoOfBedroom);
    }

    if (itemId === 2) {
      const newNoOfBathroom = [...formik.values.noOftoilet];
      newNoOfBathroom[id] = newValue;
      formik.setFieldValue("noOftoilet", newNoOfBathroom);
    }
  };

  return (
    <Box sx={{ mb: 2 }}>
      <Grid container spacing={2} alignItems={"center"}>
        <Grid item xs={6} sm={6} lg={6}>
          <b>Description</b>
        </Grid>
        <Grid item xs={6} sm={6} lg={6}>
          <b>Price</b>
        </Grid>

        {formik.values.cleaningArea.map((item: any, index: number) => (
          <React.Fragment key={item.id}>
            <Grid item xs={6} sm={6} lg={6}>
              <Stack
                direction={"row"}
                justifyContent={"space-between"}
                alignItems={"center"}
                spacing={2}
              >
                <Typography component={"span"}>Cleaning Area</Typography>
                <Box>
                  <Select
                    size="small"
                    name="cleaningArea"
                    value={formik.values.cleaningArea[index]}
                    onChange={(e) => handleSelect(index, e.target.value, 1)}
                    sx={{ width: 150, height: "48px" }}
                    displayEmpty
                    defaultValue=""
                  >
                    <MenuItem disabled value="">
                      Please select
                    </MenuItem>
                    <MenuItem value="small">Small</MenuItem>
                    <MenuItem value="medium">Medium</MenuItem>
                    <MenuItem value="large">Large</MenuItem>
                    <MenuItem value="very large">Very Large</MenuItem>
                  </Select>
                  {formik.touched.cleaningArea &&
                    formik.errors.cleaningArea && (
                      <Typography className="error">
                        {formik.errors.cleaningArea}
                      </Typography>
                    )}
                </Box>
              </Stack>
            </Grid>
            <Grid item xs={6} sm={6} lg={6}>
              <Stack spacing={2} direction={"row"} alignItems={"center"}>
                <Typography component={"span"}>$</Typography>
                <Box>
                  <Input
                    type="text"
                    name="cleaningAreaPrice"
                    value={formik.values.cleaningAreaPrice[index]}
                    onChange={(e: any) =>
                      handleChange(index, e.target.value, 1)
                    }
                  />
                  {formik.touched.cleaningAreaPrice &&
                    formik.errors.cleaningAreaPrice && (
                      <Typography className="error">
                        {formik.errors.cleaningAreaPrice}
                      </Typography>
                    )}
                </Box>
                {index === 0 ? (
                  <IconButton
                    onClick={
                      formik.values.cleaningArea.length < 4
                        ? () => handleAddButton(1)
                        : undefined
                    }
                    sx={{
                      backgroundColor: "#11b4f5",
                      color: "#FFF",
                      "&:hover": {
                        backgroundColor: "#11b4f5",
                        color: "#FFF",
                      },
                    }}
                  >
                    <AddIcon />
                  </IconButton>
                ) : (
                  <IconButton
                    onClick={() => handleRemoveButton(index, 1)}
                    sx={{
                      backgroundColor: "red",
                      color: "#FFF",
                      "&:hover": {
                        backgroundColor: "red",
                        color: "#FFF",
                      },
                    }}
                  >
                    <RemoveIcon />
                  </IconButton>
                )}
              </Stack>
            </Grid>
          </React.Fragment>
        ))}

        {formik.values.noOftoilet.map((item: any, index: number) => (
          <React.Fragment key={item.id}>
            <Grid item xs={6} sm={6} lg={6}>
              <Stack
                direction={"row"}
                justifyContent={"space-between"}
                alignItems={"center"}
                spacing={2}
              >
                <Typography component={"span"}>No of toilets</Typography>
                <Box>
                  <Select
                    size="small"
                    name="noOftoilet"
                    value={formik.values.noOftoilet[index]}
                    onChange={(e) => handleSelect(index, e.target.value, 2)}
                    sx={{ width: 150, height: "48px" }}
                    displayEmpty
                    defaultValue=""
                  >
                    <MenuItem disabled value="">
                      Please select
                    </MenuItem>
                    <MenuItem value="0-4">0-4</MenuItem>
                    <MenuItem value="4-8">4-8</MenuItem>
                    <MenuItem value="8-12">8-12</MenuItem>
                    <MenuItem value="12+">12+</MenuItem>
                  </Select>
                  {formik.touched.noOftoilet && formik.errors.noOftoilet && (
                    <Typography className="error">
                      {formik.errors.noOftoilet}
                    </Typography>
                  )}
                </Box>
              </Stack>
            </Grid>
            <Grid item xs={6} sm={6} lg={6}>
              <Stack spacing={2} direction={"row"} alignItems={"center"}>
                <Typography component={"span"}>$</Typography>
                <Box>
                  <Input
                    type="text"
                    name="noOftoiletPrice"
                    value={formik.values.noOftoiletPrice[index]}
                    onChange={(e: any) =>
                      handleChange(index, e.target.value, 2)
                    }
                  />
                  {formik.touched.noOftoiletPrice &&
                    formik.errors.noOftoiletPrice && (
                      <Typography className="error">
                        {formik.errors.noOftoiletPrice}
                      </Typography>
                    )}
                </Box>
                {index === 0 ? (
                  <IconButton
                    onClick={
                      formik.values.noOftoilet.length < 4
                        ? () => handleAddButton(2)
                        : undefined
                    }
                    sx={{
                      backgroundColor: "#11b4f5",
                      color: "#FFF",
                      "&:hover": {
                        backgroundColor: "#11b4f5",
                        color: "#FFF",
                      },
                    }}
                  >
                    <AddIcon />
                  </IconButton>
                ) : (
                  <IconButton
                    onClick={() => handleRemoveButton(index, 2)}
                    sx={{
                      backgroundColor: "red",
                      color: "#FFF",
                      "&:hover": {
                        backgroundColor: "red",
                        color: "#FFF",
                      },
                    }}
                  >
                    <RemoveIcon />
                  </IconButton>
                )}
              </Stack>
            </Grid>
          </React.Fragment>
        ))}

        {/* <Grid item xs={6} sm={6} lg={6}>
          <Typography component={"span"}>Deep clean cabinets</Typography>
        </Grid>
        <Grid item xs={6} sm={6} lg={6}>
          <Stack spacing={2} direction={"row"} alignItems={"center"}>
            <Typography component={"span"}>$</Typography>
            <Box>
              <Input
                type="text"
                name="cabinets"
                value={formik.values.cabinets}
                onChange={formik.handleChange}
              />
              {formik.touched.cabinets && formik.errors.cabinets && (
                <Typography className="error">
                  {formik.errors.cabinets}
                </Typography>
              )}
            </Box>
          </Stack>
        </Grid> */}

        {/* <Grid item xs={6} sm={6} lg={6}>
          <Typography component={"span"}>Deep clean fridge</Typography>
        </Grid>
        <Grid item xs={6} sm={6} lg={6}>
          <Stack spacing={2} direction={"row"} alignItems={"center"}>
            <Typography component={"span"}>$</Typography>
            <Box>
              <Input
                type="text"
                name="fridge"
                value={formik.values.fridge}
                onChange={formik.handleChange}
              />
              {formik.touched.fridge && formik.errors.fridge && (
                <Typography className="error">
                  {formik.errors.fridge}
                </Typography>
              )}
            </Box>
          </Stack>
        </Grid> */}

        <Grid item xs={6} sm={6} lg={6}>
          <Typography component={"span"}>Deep clean walls</Typography>
        </Grid>
        <Grid item xs={6} sm={6} lg={6}>
          <Stack spacing={2} direction={"row"} alignItems={"center"}>
            <Typography component={"span"}>$</Typography>
            <Box>
              <Input
                type="text"
                name="commercialWall"
                value={formik.values.commercialWall}
                onChange={formik.handleChange}
              />
              {formik.touched.commercialWall &&
                formik.errors.commercialWall && (
                  <Typography className="error">
                    {formik.errors.commercialWall}
                  </Typography>
                )}
            </Box>
          </Stack>
        </Grid>

        <Grid item xs={6} sm={6} lg={6}>
          <Typography component={"span"}>Deep clean windows</Typography>
        </Grid>
        <Grid item xs={6} sm={6} lg={6}>
          <Stack spacing={2} direction={"row"} alignItems={"center"}>
            <Typography component={"span"}>$</Typography>
            <Box>
              <Input
                type="text"
                name="commercialWindow"
                value={formik.values.commercialWindow}
                onChange={formik.handleChange}
              />
              {formik.touched.commercialWindow &&
                formik.errors.commercialWindow && (
                  <Typography className="error">
                    {formik.errors.commercialWindow}
                  </Typography>
                )}
            </Box>
          </Stack>
        </Grid>

        <Grid item xs={6} sm={6} lg={6}>
          <Typography component={"span"}>Deep clean carpets</Typography>
        </Grid>
        <Grid item xs={6} sm={6} lg={6}>
          <Stack spacing={2} direction={"row"} alignItems={"center"}>
            <Typography component={"span"}>$</Typography>
            <Box>
              <Input
                type="text"
                name="commercialCarpet"
                value={formik.values.commercialCarpet}
                onChange={formik.handleChange}
              />
              {formik.touched.commercialCarpet &&
                formik.errors.commercialCarpet && (
                  <Typography className="error">
                    {formik.errors.commercialCarpet}
                  </Typography>
                )}
            </Box>
          </Stack>
        </Grid>
      </Grid>
    </Box>
  );
};

export default HouseCleanCommercial;
